import { AmplitudePageName } from "utils/amplitude";
import AppointmentTimeslot from "../../../scrollable-calendar-view/components/appointment-timeslot/AppointmentTimeslot";
import BlockedIntervalTimeslot from "../../../scrollable-calendar-view/components/blocked-interval-timeslot/BlockedIntervalTimeslot";
import GCalEventTimeslot from "../../../scrollable-calendar-view/components/gcal-event-timeslot/GCalEventTimeslot";
import GroupSessionTimeslot from "../../../scrollable-calendar-view/components/group-session-timeslot/GroupSessionTimeslot";
import PlaceholderTimeslot from "../../../scrollable-calendar-view/components/placeholder-timeslot/PlaceholderTimeslot";
import styles from "./SessionEntry.module.scss";
import { MonthlyViewEventSlot } from "../../monthly-view.types";

const SessionEntry = ({
  slot,
  amplitudePageName,
}: {
  slot: MonthlyViewEventSlot;
  amplitudePageName: AmplitudePageName;
}) => {
  if (slot.type === "EMPTY" || slot.type === "EVENT_CONTINUED") {
    return <div className={styles["placeholder"]} />;
  }

  switch (slot.event.type) {
    case "appointment": {
      return (
        <AppointmentTimeslot
          appointment={slot.event.item}
          amplitudePageName={amplitudePageName}
        />
      );
    }
    case "groupSession": {
      return <GroupSessionTimeslot groupSession={slot.event.item} />;
    }
    case "gcalEvent": {
      return (
        <GCalEventTimeslot
          value={slot.event.item}
          daySpan={slot.type === "SHORT_EVENT" ? 1 : slot.daySpan}
        />
      );
    }
    case "blockedInterval": {
      return (
        <BlockedIntervalTimeslot
          blockedInterval={slot.event.item}
          daySpan={slot.type === "SHORT_EVENT" ? 1 : slot.daySpan}
        />
      );
    }
    case "placeholder": {
      return <PlaceholderTimeslot placeholder={slot.event.item} />;
    }
  }
};

export default SessionEntry;
